<!--
 * @Description: 组织弹层
 * @Autor: wangwangwang
 * @Date: 2021-01-16 15:48:58
 * @LastEditors: hexy
 * @LastEditTime: 2022-05-06 09:34:04
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="visible" width="680px" :close-on-click-modal="false" :before-close="handleClose">
    <span slot="title" class="dialog-title">{{ title || "选择数据" }}</span>
    <div v-loading="TreeLoading">
      <div style="height: 600px; overflow: auto">
        <el-input v-model="filterText" placeholder="输入关键字进行过滤"></el-input>
        <el-tree ref="tree" class="tree-line" :indent="0" :data="dataSource" show-checkbox node-key="id" highlight-current :props="defaultProps" :filter-node-method="filterNode" check-strictly @check-change="handleClick">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span v-if="showArr" :style="showArr.indexOf(data.id) !== -1 ? 'color:' + bg_color : ''">{{ node.label }}</span>
            <span v-else>{{ node.label }}</span>
          </span>
        </el-tree>
        <div v-if="currentArr.length == 0" style="text-align: center">
          <el-button v-if="!isCreatedBtn" class="bottom_all" @click="handleCreate">立即创建</el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="handleClose">关 闭</el-button>
      <el-button class="bottom_all" @click="handleSure">确 定</el-button>
    </span>
    <el-dialog v-dialogDrag :visible="innerVisible" width="30%" :close-on-click-modal="false" :before-close="handleInnerClose" title="添加组织" append-to-body top="20vh">
      <div>
        <el-form ref="innerform" :rules="rules" :model="createOrgForm">
          <el-form-item label-width="100px"> <span slot="label">上级组织</span>{{ createOrgForm.orgName }} </el-form-item>
          <!-- <el-form-item label-width="100px">
						<span slot="label">编码</span><el-input v-model="createOrgForm.code" placeholder="请输入编码" ></el-input>
					</el-form-item> -->
          <el-form-item label-width="100px" prop="name"> <span slot="label">名称</span><el-input v-model="createOrgForm.name" placeholder="请输入客户公司名称"></el-input> </el-form-item>
          <el-form-item label-width="100px" prop="shortName"> <span slot="label">简称</span><el-input v-model="createOrgForm.shortName" placeholder="请输入简称"></el-input> </el-form-item>
          <el-form-item label-width="100px"> <span slot="label">类型</span>外部公司 </el-form-item>
          <el-form-item label-width="100px">
            <span slot="label">状态</span>
            <el-radio v-model="createOrgForm.status" label="1">启用</el-radio>
            <el-radio v-model="createOrgForm.status" label="2">禁用</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="cancel">取消</el-button>
        <el-button class="bottom_all" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import styles from "@/app.scss";
import { queryOragan } from "@/api/internetSales/customer.js";
import { saveOrUpdate } from "@/api/basedata/organization.js";
import { type } from "os";
export default {
  data() {
    return {
      bg_color: styles.bg_color,
      id: "",
      name: "",
      filterText: "",
      typeNew: type,
      defaultProps: {
        children: "children",
        label: "name",
      },
      currentArr: [],
      rules: {
        name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        shortName: [{ required: true, message: "请输入简称", trigger: "blur" }],
        companyNatureId: [{ required: true, message: "请选择企业性质", trigger: "change" }],
      },
      innerTitle: "添加组织",
      innerVisible: false,
      createOrgForm: {
        code: "",
        orgName: "",
        name: "",
        shortName: "",
        parentId: "",
        orgType: "",
        imgIcon: "",
        classifyName: "",
        classifyValue: "",
        typeId: "b8f9367217ab43f8924cd6c08a9ba300",
        typeName: "外部公司",
        typeValue: "4",
        sortNum: null,
        virtualOrganization: "0",
        enable: 1,
        status: "1",
        attributes: [
          {
            attributeName: "服务等级",
            attributeNameId: "serviceRank",
            attributeValueId: "",
          },
          {
            attributeName: "工资计算规则",
            attributeNameId: "WageCalculationRules",
            attributeValueId: "",
          },
          {
            attributeName: "机构区域类型",
            attributeNameId: "MechanismAreaType",
            attributeValueId: "",
          },
          {
            attributeName: "行业",
            attributeNameId: "industry",
            attributeValueId: "",
          },
          {
            attributeName: "每天午餐补贴",
            attributeNameId: "WageCalculationRules",
            attributeValueId: "",
          },
          {
            attributeName: "机构级别",
            attributeNameId: "InstitutionalLevel",
            attributeValueId: "",
          },
          {
            attributeName: "是否工资主体",
            attributeNameId: "WhetherItIsAWageSubject",
            attributeValueId: "",
          },
          {
            attributeName: "业务类型",
            attributeNameId: "workType",
            attributeValueId: "",
          },
          {
            attributeName: "业务顶级节点",
            attributeNameId: "topWork",
            attributeValueId: "",
          },
        ],
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
      console.log(this.$refs.tree, "val", this.dataSource.length);
      // 用于判断搜索过滤后的数组长度
      this.currentArr = this.$refs.tree.root.childNodes.filter(item => {
        return item.visible == true;
      });
      console.log(this.currentArr.length, 123);
    },
    visible(val) {
      if (val && this.default) {
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys([this.default]);
        }, 100);
      }
      this.filterText = "";
    },
    innerVisible() {},
  },
  computed: {},
  mounted() {
    this.currentArr = this.dataSource;
    console.log(this.currentArr);
  },
  props: ["visible", "dataSource", "title", "type", "default", "TreeLoading", "showArr", "flag", 'isCreatedBtn'],
  methods: {
    parent() {
      this.$parent.updateOrg();
    },
    handleClick(data, checked) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleSure() {
      let checkedData = this.$refs.tree.getCheckedNodes();
      if (checkedData.length > 1) {
        checkedData = [checkedData[checkedData.length - 1]];
      }
      console.log(JSON.parse(JSON.stringify(checkedData)));
      if (!checkedData.length) {
        this.$message.warning("请选中一条数据");
        return;
      }
      this.$emit("handleSure", checkedData);
    },
    handleClose() {
      this.$emit("handleClose");
    },
    handleInnerClose() {
      this.initCreateOrgForm();
      this.innerVisible = false;
    },
    handleCreate() {
      this.innerVisible = true;
      console.log(this.type);
      queryOragan({ type: this.type }).then(res => {
        console.log(res, "客户所属组织");
        this.id = res.data.id;
        this.createOrgForm.orgName = res.data.name;
        console.log(this.id);
      });
    },
    initCreateOrgForm() {
      this.createOrgForm = {
        code: "",
        orgName: "",
        name: "",
        shortName: "",
        parentId: "",
        // briefName:'',
        // companyName:'',
        orgType: "",
        imgIcon: "",
        classifyName: "",
        classifyValue: "",
        typeId: "b8f9367217ab43f8924cd6c08a9ba300",
        typeName: "外部公司",
        typeValue: "4",
        sortNum: null,
        virtualOrganization: "0",
        enable: 1,
        status: "1",
        attributes: [
          {
            attributeName: "服务等级",
            attributeNameId: "serviceRank",
            attributeValueId: "",
          },
          {
            attributeName: "工资计算规则",
            attributeNameId: "WageCalculationRules",
            attributeValueId: "",
          },
          {
            attributeName: "机构区域类型",
            attributeNameId: "MechanismAreaType",
            attributeValueId: "",
          },
          {
            attributeName: "行业",
            attributeNameId: "industry",
            attributeValueId: "",
          },
          {
            attributeName: "每天午餐补贴",
            attributeNameId: "WageCalculationRules",
            attributeValueId: "",
          },
          {
            attributeName: "机构级别",
            attributeNameId: "InstitutionalLevel",
            attributeValueId: "",
          },
          {
            attributeName: "是否工资主体",
            attributeNameId: "WhetherItIsAWageSubject",
            attributeValueId: "",
          },
          {
            attributeName: "业务类型",
            attributeNameId: "workType",
            attributeValueId: "",
          },
          {
            attributeName: "业务顶级节点",
            attributeNameId: "topWork",
            attributeValueId: "",
          },
        ],
      };
    },
    confirm() {
      this.$refs["innerform"].validate(valid => {
        if (valid) {
					if(this.flag){
						if(this.flag == '客户') {
							this.createOrgForm.parentId = '31987067865141248';
						}else if (this.flag == '供应商') {
							this.createOrgForm.parentId = '31442704911175680';
						}
					}else {
						this.createOrgForm.parentId = this.id
					}
          saveOrUpdate(this.createOrgForm).then(res => {
            if (res.code === 1001) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.initCreateOrgForm();
              this.innerVisible = false;
              this.parent();
            }
          });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.initCreateOrgForm();
      this.innerVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-center {
  text-align: center;
  margin-top: 30px;
  button {
    margin-left: 0;
  }
}
</style>